import { LOCALE_ID } from '@angular/core'

export const AppLocaleProvider = { provide: LOCALE_ID, useValue: 'en-NZ' }
